import Base from './condition-base'
import renderFields from './gps.pug'

export default class Gps extends Base
  Object.defineProperty this, "label", get: -> @t(".label")

  renderFields: renderFields
